import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Vale from './Vales';
import { ValesData } from '../../types/Types';

interface Props {
  valesCanj: ValesData[];
  retrieveValesAhorro: any;
  isMobile: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  setPromocion: React.Dispatch<React.SetStateAction<boolean>>;
}

const ValesActivados: FC<Props> = ({
  valesCanj,
  retrieveValesAhorro,
  isMobile,
  setVisible,
  setPromocion,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="divider" />

      <h2 className="bloque-datos__title u-text-brand">
        <span className="divider__square brand-color" />
        <span className="u-margin-right">{t('vales.canjeados')}</span>
      </h2>

      <div className="listado-vales listado-vales__canjeados">
        {valesCanj.map((valeData, index) => (
          <Vale
            setPromocion={setPromocion}
            preActivado={false}
            key={`vale-${valeData.valeEAN}`}
            data={valeData}
            cargarVales={retrieveValesAhorro}
            valeIndex={isMobile ? 0 : index}
            showCondLegales={setVisible}
          />
        ))}
      </div>
    </>
  );
};

export default ValesActivados;
